'use strict';

import controller from './codigo-contrato.controller';
import template from './codigo-contrato.html';
import service  from '../../../integracion-siga/integracion.service';

const CodigoContratoComponent = {
  bindings: {
    proyecto: '=',
    modoVista: '<',
    tieneDocumentacion: '=?',
    codigoDocumentacion: '<?'
  },
  controller,
  template,
  service
};

export default CodigoContratoComponent;



// WEBPACK FOOTER //
// ./src/app/components/empresas/c-empresas/codigo-contrato/codigo-contrato.component.js